import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../lib/api';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../lib/firebase';

// Query Keys
export const qk = {
  me: ['users', 'me'] as const,
};

export function useCurrentUser() {
  return useQuery({
    queryKey: qk.me,
    queryFn: async () => {
      const resp = await api.get('/users');
      const user =
        resp.data?.user ??
        resp.data?.data?.user ?? // in case your server nests under data.user
        (Array.isArray(resp.data) ? resp.data[0] : resp.data);
      return user;
    },
  });
}

// Firebase reset email (client-side)
export function useSendResetEmail() {
  return useMutation({
    mutationFn: async (email: string) => {
      await sendPasswordResetEmail(auth, email.trim(), {
        url: `${window.location.origin}/login`,
        handleCodeInApp: true,
      });
      return true;
    },
  });
}

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { name?: string; phone?: string }) => {
      const resp = await api.post('/users', payload);
      return resp.data;
    },
    onSuccess: () => {
      // refresh the cached user
      qc.invalidateQueries({ queryKey: qk.me });
    },
  });
}
